import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';
const CreateLocation = {
  name: 'createLocation',
  state: {
    data: {},
    loading: false,
    error: '',
  },
  reducers: {
    createRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    createSucceeded(state, payload) {
      return {
        ...state,
        data: payload,
        loading: false,
        error: '',
      };
    },

    createFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
  },
  effects: (dispatch) => ({
    async createNewLocation({ address,
      latitude,
      location_name,
      longitude,
      schedule }) {
      try {
        // Simulating fetching org_id from local storage or user info
        const userInfo = JSON.parse(localStorage.getItem('userInfo'));
        const org_id = userInfo.org_id;
        const payload = {
          address,
          location_name,
          location: {
            latitude,
            longitude,
          },
          org_id,
          schedule
        };

        this.createRequested();

        const response = await http.post('savvy/locations', payload);
        if (response && response.data) {
          dispatch.ProgressStepDSO.UpdateGetDSOProgressStep(1);
        }
        this.createSucceeded(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Location created successfully!',
            show: true,
          },
        });
      } catch (error) {
        this.createFailed(error.message);
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(error.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default CreateLocation;
